"use strict";

function last(a) {
  return a[a.length - 1];
}

function first(a) {
  return a[0];
}

module.exports = {
  last: last,
  first: first
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/docxtemplater/js/utils.js
// module id = c1+O
// module chunks = 0